import React, { useEffect, useState } from "react";
import { Form } from "antd";
import dayjs from "dayjs";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import { StyledGridCol, StyledGridRow, StyledSectionHeading } from "@/common/styles";
import {
  getOptionsFromRefList,
} from "@/util/common_function";
import TextField from "@/common/elements/InputElements/TextField";
import CommonDatePicker from "@/common/elements/DatePicker";
import TimePicker from "@/common/elements/TimePicker";
import {
  getRefListNameByID,
} from "@/util/common_function";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";

const GroupMembersForm2 = ({ form, initialValues = {}, onFinish, disabled }) => {
  const [staffGroup,setStaffGroup]=useState([])
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  useEffect(() => {
    if (initialValues?.staffGroupsID) {
      form.setFieldsValue({
        staffGroupsId: initialValues?.staffGroupsID,
        memberStaffId: initialValues?.memberStaffId,
        id: initialValues?.memberStaffId,
        dateAdded: initialValues.dateAdded
          ? dayjs(initialValues.dateAdded)
          : dayjs(),
        timeAdded: initialValues.timeAdded
          ? dayjs(initialValues.timeAdded, "HH:mm")
          : dayjs(),
        user: initialValues.user || getRefListNameByID("", userDetails?.staffId, true, false),
      });
    } else {
      if(form) form.resetFields();
    }
  }, [initialValues, form,staffGroup]);
  useEffect(() => {
    api
      .get(API_ENDPOINTS.security.staffGroups.getAll)
      .then((resp) => {
        const groupData = resp.data;

        const list = groupData
          ?.map((e) => ({
            value: e.staffGroupsID,
            label: e.groupName ?? "",
          }))
          ?.sort((a, b) => a.label.localeCompare(b.label));

        if (list?.length) {
          setStaffGroup(list);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch staff groups", err);
      });
  }, []);
  return (
    <>
      <StyledSectionHeading>
        <span>Staff Member Information</span>
      </StyledSectionHeading>


      <Form form={form} onFinish={onFinish} disabled={disabled}>

        <StyledGridRow gutter={16}>
          <StyledGridCol lg={12}>
            {/* keep the ID in the payload, but hidden from the user */}
 
            <FormItem name="staffGroupMembersID" style={{ display: 'none' }}>
              <TextField type="hidden" id="staffGroupMembersID" />
            </FormItem>
            <FormItem
              name="staffGroupsId"
              label="Staff Group To Add"
              rules={[{ required: true, message: "Please select a staff group" }]}
            >
              <Select
                showSearch
                labelInValue
                placeholder="Select group..."
                options={staffGroup}
                disabled={disabled}
              />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>

        {/* Administrative Info */}
        <StyledSectionHeading marginTop="20px">
          <span>Staff Group Member Administrative Information</span>
        </StyledSectionHeading>
        <StyledGridRow gutter={16}>
          <StyledGridCol lg={2}>
            <FormItem name="id" label="Id">
              <TextField disabled />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={6}>
            <FormItem name="dateAdded" label="Date Entered">
              <CommonDatePicker placeholder="MM/DD/YYYY" format="MM/DD/YYYY" disabled />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={6}>
            <FormItem name="timeAdded" label="Time Entered">
              <TimePicker placeholder="HH:mm" format="HH:mm" disabled />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={6}>
            <FormItem name="user" label="User">
              <TextField disabled />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
      </Form>
    </>
  );
};

export default GroupMembersForm2;
